const angular = require('angular');

const CLOSED = 'closed';

class DropdownManagerService {

    public static $inject = ['$window', '$rootScope'];

    public state = {
        appSwitcher: CLOSED,
        profileDropdown: CLOSED,
    };

    constructor($window, $rootScope) {
        $window.addEventListener('clickOut', () => {
            $rootScope.$evalAsync(() => {
                this.state.appSwitcher = CLOSED;
                this.state.profileDropdown = CLOSED;
            });
        });
        $window.addEventListener('openRxDropdown', () => {
            $rootScope.$evalAsync(() => {
                this.state.appSwitcher = CLOSED;
                this.state.profileDropdown = CLOSED;
            });
        })
    }

    /**
     * close all dropdown by dispatching a clickOut event
     */
    public closeAll = () => {
        const clickOut: Event = new CustomEvent('clickOut');
        dispatchEvent(clickOut);
    }

}

export default angular
    .module('spsng.services.dropdown-manager', [])
    .service('DropdownManagerService', DropdownManagerService)
    .name;
